'use es6';

import { createAction } from 'redux-actions';
import { apiBootstrapSubmissions } from 'FormsUI/api/SubmissionsBootstrap';
import { getSubmissionBootstrapRequestState } from 'FormsUI/selectors/SubmissionsBootstrap';
export const requestSubmissionBootstrap = createAction('@@submissions/REQUEST_SUBMISSION_BOOTSTRAP', formGuid => ({
  formGuid
}));
export const requestSubmissionBootstrapFail = createAction('@@submissions/REQUEST_SUBMISSION_BOOTSTRAP_FAIL', (formGuid, error) => ({
  payload: error,
  formGuid
}));
export const requestSubmissionBootstrapSuccess = createAction('@@submissions/REQUEST_SUBMISSION_BOOTSTRAP_SUCCESS', (formGuid, payload) => ({
  payload,
  formGuid
}));
export const bootstrapSubmissions = formGuid => (dispatch, getState) => {
  if (!getSubmissionBootstrapRequestState(getState(), formGuid).shouldBeRequested()) return;
  dispatch(requestSubmissionBootstrap(formGuid));
  apiBootstrapSubmissions(formGuid).then(data => {
    dispatch(requestSubmissionBootstrapSuccess(formGuid, data));
  }).catch(error => {
    dispatch(requestSubmissionBootstrapFail(formGuid, error));
  });
};